// @flow
import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { BASE_URL } from "utils/Config";
import styles from "./Image.styles.js";

type Props = {
  classes: any,
  className?: any,
  src: string,
  objectFit?: string,
  placeholder?: any,
  circle?: boolean,
  fill?: boolean,
  cover?: boolean,
  border?: ?boolean,
  alt?: String,
  block?: boolean,
  component?: any,
  style?: any
};

type State = {
  fillerStyle?: any,
  src?: string,
  style?: any,
  placeholder?: string,
  component?: any
};

class Image extends React.Component<Props, State> {
  placeholderUrl = `${BASE_URL}/caffecinema/img/placeholder.png`;
  onErrorCount = 0;

  constructor(props) {
    super(props);

    this.state = {
      src: "",
      style: {},
      component: "div"
    };
  }

  makeImageProps = () => {
    // const baseURL = 'https://caffecinema.com';
    const src =
      this.props.src && this.props.src.match(/^https?:\/\//)
        ? this.props.src
        : `${BASE_URL}${this.props.src}`;

    let placeholder = "";
    if (this.props.placeholder) {
      placeholder = `${BASE_URL}/caffecinema/img/placeholder.png`;
    }
    const backgroundImage = src || placeholder;
    let style = this.props.style;

    let fillerStyle = {
      backgroundImage: `url('${backgroundImage}')`,
      backgroundSize: "cover",
      backgroundPosition: "center center"
      // border: '1px solid rgba(255, 255, 255, 0)'
    };

    let component = this.state.component;
    if (this.props.component && this.state.component !== this.props.component) {
      component = this.props.component;
    }
    this.setState({ src, style, fillerStyle, component });
  };

  componentDidMount() {
    this.makeImageProps();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src && this.props.src) {
      this.makeImageProps();
    }
  }

  onImageError = e => {
    return this.onErrorCount++ < 1 ? (e.target.src = this.placeholderUrl) : null;
  };

  render() {
    const {
      classes,
      className,
      alt,
      border,
      block,
      cover,
      circle,
      objectFit,
      overlayShadow,
      placeholder,
      fill,
      ...props
    } = this.props;
    const circleClass = circle ? classes.circle : "";
    return (
      <this.state.component
        className={classNames(
          className && className.root,
          classes.container,
          circleClass
        )}
      >
        {cover && (
          <div
            className={classNames(
              className && className.image,
              classes.image,
              circleClass
            )}
            style={this.state.fillerStyle}
          >
            {overlayShadow && <div className={classes.overlayShadow}></div>}
            <div className={classes.spacer}></div>
          </div>
        )}
        {!cover && (
          <img
            className={classNames(
              className && className.image,
              classes.image,
              circleClass
            )}
            {...props}
            alt={alt || "کافه سینما"}
            src={this.state.src}
            style={this.state.style}
            onError={this.onImageError}
          />
        )}
      </this.state.component>
    );
  }
}

const Component = withStyles(styles)(Image);
export { Component as Image };
export default Component;
